
import styles from "./TestForm.module.scss";
import { useTranslation } from 'react-i18next'
import { Button, Layout } from "components";
import { useState } from 'react';
import single_selection_icon from 'assets/icons/testicons/single_selection.png'
import add_icon from 'assets/icons/testicons/add.png'
import list_icon from 'assets/icons/testicons/list.png'
import numeric_icon from 'assets/icons/testicons/numeric.png'
import textbox_icon from 'assets/icons/testicons/text-box.png'
import equalizer_icon from 'assets/icons/testicons/equalizer.png'
import freedom_of_speech_icon from 'assets/icons/testicons/freedom-of-speech.png'
import planning_icon from 'assets/icons/testicons/planning.png'
import accordance_icon from 'assets/icons/testicons/list_acc.png'
import gap_icon from 'assets/icons/testicons/gap.png'
import textfield_icon from 'assets/icons/testicons/text-field.png'
import dictation_icon from 'assets/icons/testicons/dictation.png'
import slider_icon from 'assets/icons/testicons/slider.png'
import exception_icon from 'assets/icons/testicons/exception.png'
import document_icon from 'assets/icons/testicons/document.png'
import info_icon from 'assets/icons/testicons/info.png'
import alphabet_icon from 'assets/icons/testicons/alphabet.png'
import hierarchicalstructure_icon from 'assets/icons/testicons/hierarchical-structure.png'
import index_icon from 'assets/icons/testicons/index.png'
import icon_delete from 'assets/icons/delete.png'
import Notification from "utils/Notifications";
import { EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import { PostPartWorkTest } from "service/TestService";
const buttonData = [
    { id: 'singleSelection', icon: single_selection_icon, label: 'Одиночный выбор' },
    { id: 'multipleSelection', icon: list_icon, label: 'Множественный выбор' },
    { id: 'numericInput', icon: numeric_icon, label: 'Ввод числа' },
    { id: 'textInput', icon: textbox_icon, label: 'Ввод текста' },
    { id: 'freeTextAnswer', icon: freedom_of_speech_icon, label: 'Ответ в свободной форме' },
    { id: 'sequenceOrdering', icon: planning_icon, label: 'Установление последовательности' },
    { id: 'slider', icon: slider_icon, label: 'Слайдер (ползунок)' },
    { id: 'fileUpload', icon: document_icon, label: 'Загрузка файла' },
    { id: 'infoText', icon: info_icon, label: 'Информационный текст' },
];


const TestForm = ({ id, setRender }) => {
  const { t } = useTranslation('common')

    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });
    const [selected, setSelected] = useState(null);


    const handleSelection = (id) => {
        setRows([
            { id: 1, textValue: "", score: 0, min: "", max: "", isChecked: false, file: null },
        ]);
        setNumberField('');
        setSelectField('100');
        setPointsWrong('');
        setPointsCorrect('');
        setSelected(id);
        if (id === 'sequenceOrdering') {
            setCheckpoints(false)
        }

    };


    const [text, setText] = useState('');

    const handleChange = (event) => {
        setText(event.target.value);
    };


    const [rows, setRows] = useState([
        { id: 1, editorState: EditorState.createEmpty(), score: 0, ranswer: 0, file: null, textValue: "", min: "", max: "" },
    ]);


    const addRow = () => {
        const newRow = {
            id: rows.length + 1,
            editorState: EditorState.createEmpty(),
            score: 0,
        };
        setRows([...rows, newRow]);
    };

    const removeRow = (id) => {
        const updatedRows = rows
            .filter((row) => row.id !== id)
            .map((row, index) => ({
                ...row,
                id: index + 1, 
            }));
        setRows(updatedRows);
    };
    const moveRow = (index, direction) => {
        const newRows = [...rows];

        if (direction === "up" && index > 0) {
            const temp = newRows[index];
            newRows[index] = newRows[index - 1];
            newRows[index - 1] = temp;
        }
        else if (direction === "down" && index < rows.length - 1) {
            const temp = newRows[index];
            newRows[index] = newRows[index + 1];
            newRows[index + 1] = temp;
        }

        const updatedRows = newRows.map((row, i) => ({
            ...row,
            id: i + 1, 
        }));

        setRows(updatedRows);
    };
    const [selectField, setSelectField] = useState('100');

    const [pointswrong, setPointsWrong] = useState('');
    const [pointscorrect, setPointsCorrect] = useState('');
    const [numberField, setNumberField] = useState('');
    const [file, setFile] = useState(null);

    const handleFileChange_test = (e) => {
        setFile(e.target.files[0]);
    };

    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [editorStateComment, setEditorStateCom] = useState(EditorState.createEmpty());

    const onEditorStateChangeComment = (newState) => {
        setEditorStateCom(newState);
    };

    const onEditorStateChange = (newState) => {
        setEditorState(newState);
    };

    const handleEditorChange = (index, newEditorState) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, editorState: newEditorState } : row
        );
        setRows(updatedRows);
    };

    const handleScoreChange = (index, newScore) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, score: newScore } : row
        );
        setRows(updatedRows);
    };
    const handleRightAnChange = (index, newRanswer) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, ranswer: newRanswer } : row
        );
        setRows(updatedRows);
    };

    const [checkpoints, setCheckpoints] = useState(true);

    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;

        if (e.target.name === "first") {
            setCheckpoints(isChecked); 
        } else if (e.target.name === "second") {
            setCheckpoints(!isChecked); 
        }
    };
    const handleNumericChange = (index, value) => {
        const updatedRows = [...rows];
        updatedRows[index] = {
            ...updatedRows[index],
            numericValue: value,
        };
        setRows(updatedRows);
    };

    const handleTextChange = (index, value, field) => {
        const updatedRows = [...rows];
        updatedRows[index] = {
            ...updatedRows[index],
            [field]: value,
        };
        setRows(updatedRows);
    };
    const handleOptionalNumericChange = (index, value) => {
        const updatedRows = [...rows];
        updatedRows[index] = {
            ...updatedRows[index],
            optionalNumericValue: value,
        };
        setRows(updatedRows);
    };

    const handleCheckboxChange_row = (index, isChecked) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, isChecked } : row
        );
        setRows(updatedRows);
    };


    const handleFileChange = (index, file) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, file: file } : row
        );
        setRows(updatedRows);
    };

    const handleSelectChange = (index, newValue) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, selectedNumber: newValue } : row
        );
        setRows(updatedRows);
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!editorState || !editorState.getCurrentContent().hasText()) {
            setNotify({
                isOpen: true,
                message: "Пожалуйста, заполните текст вопроса.",
                type: "error",
            });
            return;  
        }

        const formData = new FormData();


        formData.append('checkpoints', checkpoints)
        formData.append('max_points_for_the_correct_answer', numberField);
        formData.append('type_answer', selected);
        formData.append('points_for_the_wrong_answer', pointswrong);
        formData.append('points_for_the_correct_answer', pointscorrect);
        formData.append('max_len', selectField);

        if (file) {
            formData.append('image', file); 
        }
        formData.append('body', convertEditorStateToRaw(editorState));
        formData.append('comment', convertEditorStateToRaw(editorStateComment));

        const rowsData = rows.map(row => ({
            answer_number: row.id,
            points: row.score || 0,
            ranswer: row.ranswer || 0,
            min_len: row.min || "",
            max_len: row.max || "",
            right_answer: row.isChecked || false,
            sequences_selectedNumber: row.selectedNumber || 1,
            type_input_txt: row.textValue || "",
            type_input_int: row.numericValue || null,
            error_rate: row.optionalNumericValue || null,
            title: row.editorState ? convertEditorStateToRaw(row.editorState) : null,
        }));

        formData.append('parts', JSON.stringify(rowsData));

        rows.forEach((row, index) => {
            if (row.file) {
                formData.append(`imageparts[${index}]`, row.file);
            }
        });

        try {
            const response = await PostPartWorkTest(id, formData); 
            setNotify({
                isOpen: true,
                message: "Данные успешно отправлены!",
                type: "success",
            });

            setRows([
                { id: 1, textValue: "", score: 0, min: "", max: "", isChecked: false, file: null },
            ]);
            setNumberField('');
            setSelectField('100');
            setFile(null);
            setPointsWrong('');
            setPointsCorrect('');
            setEditorState(EditorState.createEmpty());
            setRender(true)
        } catch (error) {
            setNotify({
                isOpen: true,
                message: "Ошибка при отправке данных!",
                type: "error",
            });
        }
    };

    const convertEditorStateToRaw = (editorState) => {
        return editorState ? JSON.stringify(convertToRaw(editorState.getCurrentContent())) : null;
    };

    return (
        <div className={styles.test_card_body_aud}>
            <div className={styles.test_card_body}>
                <div className={styles.test_card_right_2}>
                    <div className={styles.buttons_set}>
                        <select
                            className={styles.select_test}
                            onChange={(e) => handleSelection(e.target.value)} 
                        >
                            {buttonData.map((button) => (
                                <option key={button.id} value={button.id}>
                                    {button.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                {selected !== null ? (<>
                    <div className={styles.test_card_left}>

                        <div className={styles.div_selection}>
                            {selected === 'singleSelection' && <h2>{t('surveyForm.single_selection')}</h2>}
                            {selected === 'multipleSelection' && <h2>{t('surveyForm.multiple_selection')}</h2>}
                            {selected === 'numericInput' && <h2>{t('surveyForm.numeric_input')}</h2>}
                            {selected === 'textInput' && <h2>{t('surveyForm.text_input')}</h2>}
                            {selected === 'freeTextAnswer' && <h2>{t('surveyForm.free_text_defendant')}</h2>}
                            {selected === 'sequenceOrdering' && <h2>{t('testForm.sequence_ordering')}</h2>}
                            {selected === 'slider' && <h2>{t('testForm.slider')}</h2>}
                            {selected === 'fileUpload' && <h2>{t('surveyForm.file_upload')}</h2>}
                            {selected === 'infoText' && <h2>{t('surveyForm.info_text')}</h2>}
                            {selected === 'wordsFromLetters' && <h2>{t('surveyForm.words_from_letters')}</h2>}
                            {selected === 'phrasesFromWords' && <h2>{t('surveyForm.phrases_from_words')}</h2>}
                            {selected === 'textSearch' && <h2>{t('surveyForm.text_search')}</h2>}
                            <button
                                onClick={handleSubmit}
                                style={{
                                    padding: "12px 20px",
                                    backgroundColor: "#27ae60",
                                    color: "#fff",
                                    border: "none",
                                    cursor: "pointer",
                                    borderRadius: "6px",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    fontFamily: "var(--font-base, Inter, sans-serif)",
                                    transition: "all 0.2s ease"
                                }}
                            >
                                {t('surveyForm.save_element')}
                            </button>
                        </div>
                        <div className={styles.test_card_left_selection}>
                            <div>
                                <label>{t('testForm.image_label')}  </label>

                                <input
                                    type="file"
                                    id="file-upload"
                                    className={styles.file_upload_input}
                                    onChange={handleFileChange_test}  
                                />
                                <label htmlFor="file-upload" className={styles.file_upload_label}>
                                    {file ? file.name : 'Загрузите изображение'}
                                </label>
                            </div>

                            <div>
                                <label>{t('surveyForm.question_text')}</label>
                                <Editor
                                    editorState={editorState}
                                    onEditorStateChange={onEditorStateChange}
                                    toolbar={{
                                        options: ["inline", "blockType", "list", "textAlign", "link", "history"],
                                        inline: { options: ["bold", "italic", "underline", "strikethrough"] },
                                    }}
                                    wrapperStyle={{ border: "1px solid #ccc", marginBottom: "20px" }}
                                    editorStyle={{ minHeight: "200px", padding: "10px" }}
                                />


                            </div>
                            <div className={styles.point_multi_div}>
                                {(selected === 'multipleSelection' || selected === 'numericInput' || selected === 'textInput' || selected === 'slider' || selected === 'sequenceOrdering') &&

                                    <>

                                        <div className={styles.point_multi_directions}>
                                            Подсчет баллов:
                                            {selected !== 'sequenceOrdering' &&
                                                <div className={styles.point_multi}>
                                                    <label>{t('testForm.by_answers')}</label>
                                                    <input
                                                        type="checkbox"
                                                        name="first"
                                                        checked={checkpoints}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                </div>
                                            }
                                            {selected !== 'sequenceOrdering' &&
                                                <div className={styles.point_multi}>
                                                    <label>{t('testForm.whole_question')}</label>
                                                    <input
                                                        type="checkbox"
                                                        name="second"
                                                        checked={!checkpoints} 
                                                        onChange={handleCheckboxChange}
                                                    />
                                                </div>
                                            }
                                        </div>

                                        <div className={styles.point_multi_directions}>
                                            {checkpoints === false &&
                                                <>


                                                    <div className={styles.point_multi}>
                                                        <span>За <span className={styles.point_color_1}>{t('testForm.correct')}</span> ответ</span>

                                                        <input
                                                            type="number"
                                                            className={styles.point_check}
                                                            value={pointscorrect}  
                                                            onChange={(e) => setPointsCorrect(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className={styles.point_multi}>

                                                        <span>За  <span className={styles.point_color_2}>{t('testForm.wrong')}</span> ответ</span>

                                                        <input
                                                            type="number"
                                                            className={styles.point_check}
                                                            value={pointswrong}  
                                                            onChange={(e) => setPointsWrong(e.target.value)}
                                                        />
                                                    </div>

                                                </>}
                                        </div>
                                    </>}
                            </div>

                            <div>

                                <div>
                                    {(selected === 'freeTextAnswer' || selected === 'fileUpload') &&
                                        <p style={{ fontSize: '12px' }}>  {t('auto.testform_testform.k1')}</p>
                                    }
                                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr>
                                                {(selected !== 'freeTextAnswer' && selected !== 'fileUpload' && selected !== 'infoText') &&
                                                    <th className={styles.test_row_title}>№</th>}
                                                {(selected === 'singleSelection' || selected === 'multipleSelection' || selected === 'sequenceOrdering') &&
                                                    <th className={styles.test_row_title}>{t('surveyForm.th_image')}</th>}
                                                {(selected === 'singleSelection' || selected === 'multipleSelection' || selected === 'sequenceOrdering') &&
                                                    <th className={styles.test_row_title}>
                                                        {t('surveyForm.th_answer_text')}
                                                    </th>}

                                                {(selected === 'slider') &&
                                                    <th className={styles.test_row_title}>
                                                        {t('surveyForm.th_slider_name')}
                                                    </th>}
                                                {(selected === 'numericInput' || selected === 'textInput') &&
                                                    <th className={styles.test_row_title}>
                                                        {t('test.correct_answer')}
                                                    </th>}

                                                {(selected === 'numericInput') &&
                                                    <th className={styles.test_row_title}>
                                                        {t('auto.testform_testform.k2')}
                                                    </th>}
                                                {(selected === 'slider') && <th className={styles.test_row_title}>
                                                    {t('testForm.th_correct_value')}
                                                </th>}
                                                {(((selected === 'singleSelection' || (selected === 'slider' && checkpoints === true)) || checkpoints === true) && (selected !== 'freeTextAnswer' && selected !== 'sequenceOrdering' && selected !== 'fileUpload' && selected !== 'infoText')) && <th className={styles.test_row_title}>
                                                    {t('testForm.th_score')}
                                                </th>}


                                                {selected === 'freeTextAnswer' && <>
                                                    <th className={styles.test_row_title}>
                                                        {t('testForm.max_score')}
                                                    </th>
                                                    <th className={styles.test_row_title}>
                                                        {t('testForm.max_chars')}
                                                    </th>
                                                </>
                                                }
                                                {((selected === 'multipleSelection' && checkpoints === false) || selected === 'sequenceOrdering') &&

                                                    <th className={styles.test_row_title}>
                                                        {t('test.correct_answer')}
                                                    </th>
                                                }


                                                {(selected !== 'freeTextAnswer' && selected !== 'fileUpload' && selected !== 'infoText') &&

                                                    <th className={styles.test_row_title}>
                                                        {t('common.actions')}
                                                    </th>
                                                }
                                            </tr>
                                        </thead>
                                        {(selected === 'freeTextAnswer') &&

                                            <tbody>

                                                <td className={styles.test_row}>
                                                    <input
                                                        type="number"
                                                        className={styles.point_check_num_text}
                                                        value={numberField}  
                                                        onChange={(e) => setNumberField(e.target.value)}  
                                                    />
                                                </td>
                                                <td className={styles.test_row}>
                                                    <select
                                                        className={styles.point_check_num_text}
                                                        value={selectField}  
                                                        onChange={(e) => setSelectField(e.target.value)}  
                                                    >
                                                        <option value="100">100</option>
                                                        <option value="250">250</option>
                                                        <option value="500">500</option>
                                                        <option value="750">750</option>
                                                        <option value="1000">1000</option>
                                                        <option value="1500">1500</option>
                                                        <option value="2000">2000</option>
                                                        <option value="2500">2500</option>
                                                        <option value="5000">5000</option>
                                                        <option value="10000">10000</option>
                                                        <option value="15000">15000</option>
                                                    </select>
                                                </td>

                                            </tbody>
                                        }
                                        {selected === 'fileUpload' &&
                                            <tbody>
                                                <td>

                                                    Максимальное кол-во баллов:
                                                    <input
                                                        type="number"
                                                        className={styles.point_check_num_text}
                                                        value={numberField}  
                                                        onChange={(e) => setNumberField(e.target.value)}  
                                                    />
                                                </td>
                                            </tbody>
                                        }
                                        {(selected !== 'freeTextAnswer' && selected !== 'fileUpload' && selected !== 'infoText') &&
                                            <tbody>
                                                {rows.map((row, index) => (
                                                    <tr key={row.id}>
                                                        {selected !== 'freeTextAnswer' &&
                                                            <td className={styles.test_row}>
                                                                {row.id}
                                                            </td>
                                                        }
                                                        {(selected === 'singleSelection' || selected === 'multipleSelection' || selected === 'sequenceOrdering') &&
                                                            <td className={styles.test_row}>

                                                                
                                                                <input
                                                                    type="file"
                                                                    id={`file-upload-${row.id}`}  
                                                                    className={styles.file_upload_input}
                                                                    onChange={(e) => handleFileChange(index, e.target.files[0])}
                                                                />
                                                                <label htmlFor={`file-upload-${row.id}`} className={styles.file_upload_label}>
                                                                    {row.file ? row.file.name : 'Загрузить изображение'}
                                                                </label>


                                                            </td>
                                                        }
                                                        {(selected === 'singleSelection' || selected === 'multipleSelection' || selected === 'sequenceOrdering') &&
                                                            <td className={styles.test_row}>
                                                                <Editor
                                                                    editorState={row.editorState}
                                                                    onEditorStateChange={(newEditorState) =>
                                                                        handleEditorChange(index, newEditorState)
                                                                    }
                                                                    toolbar={{
                                                                        options: [
                                                                            "inline",
                                                                            "blockType",
                                                                            "list",
                                                                            "textAlign",
                                                                            "link",
                                                                            "history",
                                                                        ],
                                                                        inline: {
                                                                            options: ["bold", "italic", "underline", "strikethrough"],
                                                                        },

                                                                    }}
                                                                    wrapperStyle={{
                                                                        border: "1px solid #ccc",
                                                                    }}
                                                                    editorStyle={{
                                                                        minHeight: "50px",
                                                                        padding: "5px",
                                                                    }}
                                                                />
                                                            </td>
                                                        }

                                                        {(selected === 'numericInput') &&
                                                            <td className={styles.test_row}>
                                                                <input
                                                                    type="number"
                                                                    className={styles.point_check_num_text}
                                                                    value={row.numericValue || ''} 
                                                                    onChange={(e) => handleNumericChange(index, e.target.value)}
                                                                />
                                                            </td>
                                                        }

                                                        {(selected === 'textInput') &&
                                                            <td className={styles.test_row}>
                                                                <input
                                                                    type="text"
                                                                    className={styles.point_check_num_text}
                                                                    value={row.textValue || ''} 
                                                                    onChange={(e) => handleTextChange(index, e.target.value, "textValue")}
                                                                />
                                                            </td>
                                                        }
                                                        {(selected === 'slider') &&
                                                            <td className={styles.test_row}>
                                                                <input
                                                                    type="text"
                                                                    className={styles.point_check_num_text}
                                                                    value={row.textValue || ""}
                                                                    onChange={(e) => handleTextChange(index, e.target.value, "textValue")}
                                                                />
                                                                <tr className={styles.point_check_under_tr}>
                                                                    <td>
                                                                        <label>{t('surveyForm.min_value')}</label>
                                                                        <input
                                                                            type="number"
                                                                            className={styles.point_check_num_text}
                                                                            value={row.min || ""}
                                                                            onChange={(e) => handleTextChange(index, e.target.value, "min")}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <label>{t('surveyForm.max_value')}</label>
                                                                        <input
                                                                            type="number"
                                                                            className={styles.point_check_num_text}
                                                                            value={row.max || ""}
                                                                            onChange={(e) => handleTextChange(index, e.target.value, "max")}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            </td>
                                                        }
                                                        {(selected === 'numericInput') &&
                                                            <td className={styles.test_row}>
                                                                +-<input
                                                                    type="number"
                                                                    className={styles.point_check}
                                                                    value={row.optionalNumericValue || ''} 
                                                                    onChange={(e) => handleOptionalNumericChange(index, e.target.value)}
                                                                />
                                                            </td>
                                                        }
                                                        {(((selected === 'slider'))) && <td className={styles.test_row}>
                                                            <input
                                                                type="number"
                                                                value={row.ranswer}
                                                                className={styles.point_check}
                                                                onChange={(e) =>
                                                                    handleRightAnChange(index, parseInt(e.target.value, 10) || 0)
                                                                }

                                                            />
                                                        </td>
                                                        }
                                                        {(((selected === 'singleSelection') || checkpoints === true) && (selected !== 'freeTextAnswer' && selected !== 'sequenceOrdering')) && <td className={styles.test_row}>
                                                            <input
                                                                type="number"
                                                                value={row.score}
                                                                className={styles.point_check}
                                                                onChange={(e) =>
                                                                    handleScoreChange(index, parseInt(e.target.value, 10) || 0)
                                                                }

                                                            />
                                                        </td>
                                                        }


                                                        {(selected === 'multipleSelection' && checkpoints === false) &&
                                                            <td className={styles.test_row}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={row.isChecked}  
                                                                    className={styles.point_check}
                                                                    onChange={(e) => handleCheckboxChange_row(index, e.target.checked)}
                                                                />
                                                            </td>
                                                        }

                                                        {(selected === 'sequenceOrdering') &&
                                                            <td className={styles.test_row}>
                                                                <select
                                                                    className={styles.point_check}
                                                                    value={row.selectedNumber || ''}  
                                                                    onChange={(e) => handleSelectChange(index, parseInt(e.target.value, 10))}
                                                                >
                                                                    {Array.from({ length: rows.length }, (_, i) => (
                                                                        <option key={i} value={i + 1}>
                                                                            {i + 1}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </td>}
                                                        {selected !== 'freeTextAnswer' && <>
                                                            <td className={styles.test_row}>
                                                                {index > 0 && (
                                                                    <button
                                                                        onClick={() => moveRow(index, "up")}
                                                                        style={{
                                                                            padding: "8px 12px",
                                                                            backgroundColor: "#27ae60",
                                                                            color: "#fff",
                                                                            border: "none",
                                                                            borderRadius: "6px",
                                                                            cursor: "pointer",
                                                                            fontWeight: "600",
                                                                            fontSize: "14px",
                                                                            fontFamily: "var(--font-base, Inter, sans-serif)",
                                                                            transition: "all 0.2s ease",
                                                                            marginBottom: "12px"
                                                                        }}
                                                                    >
                                                                        ↑
                                                                    </button>
                                                                )}

                                                                <button
                                                                    onClick={() => removeRow(row.id)}
                                                                    style={{
                                                                        padding: "8px 12px",
                                                                        backgroundColor: "#e74c3c",
                                                                        color: "#fff",
                                                                        border: "none",
                                                                        borderRadius: "6px",
                                                                        cursor: "pointer",
                                                                        fontWeight: "600",
                                                                        fontSize: "14px",
                                                                        fontFamily: "var(--font-base, Inter, sans-serif)",
                                                                        transition: "all 0.2s ease",
                                                                        marginBottom: "12px"
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={icon_delete}
                                                                        className={styles.img}
                                                                    />
                                                                </button>

                                                                {index < rows.length - 1 && (
                                                                    <button
                                                                        onClick={() => moveRow(index, "down")}
                                                                        style={{
                                                                            padding: "8px 12px",
                                                                            backgroundColor: "#f39c12",
                                                                            color: "#fff",
                                                                            border: "none",
                                                                            borderRadius: "6px",
                                                                            cursor: "pointer",
                                                                            fontWeight: "600",
                                                                            fontSize: "14px",
                                                                            fontFamily: "var(--font-base, Inter, sans-serif)",
                                                                            transition: "all 0.2s ease"
                                                                        }}
                                                                    >
                                                                        ↓
                                                                    </button>
                                                                )}
                                                            </td>
                                                        </>}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        }
                                    </table>
                                    {(selected !== 'freeTextAnswer' && selected !== 'fileUpload' && selected !== 'infoText') &&
                                        <button
                                            onClick={addRow}
                                            style={{
                                                marginTop: "20px",
                                                padding: "12px 20px",
                                                backgroundColor: "#3498db",
                                                color: "#fff",
                                                border: "none",
                                                cursor: "pointer",
                                                borderRadius: "6px",
                                                fontWeight: "600",
                                                fontSize: "14px",
                                                fontFamily: "var(--font-base, Inter, sans-serif)",
                                                transition: "all 0.2s ease"
                                            }}
                                        >
                                            {t('surveyForm.add_row')}
                                        </button>
                                    }

                                    <div style={{ marginTop: '40px' }}>
                                        <label>{t('surveyForm.question_note')}</label>
                                        <Editor
                                            editorState={editorStateComment}
                                            onEditorStateChange={onEditorStateChangeComment}
                                            toolbar={{
                                                options: ["inline", "blockType", "list", "textAlign", "link", "history"],
                                                inline: { options: ["bold", "italic", "underline", "strikethrough"] },
                                            }}
                                            wrapperStyle={{ border: "1px solid #ccc", marginBottom: "20px" }}
                                            editorStyle={{ minHeight: "100px", padding: "10px" }}
                                        />


                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </>) : (
                    <div className={styles.test_card_left_none}>
                        <h4 >
                            В вашем тесте еще нет ни одного вопроса.<br></br>
                            Чтобы добавить новый вопрос выберите необходимые элементы в правой навигации экрана для показа панели со списком вопросов.
                        </h4>
                    </div>
                )}
                <div className={styles.test_card_right}>
                    <div className={styles.buttons_set}>
                        {buttonData.map((button) => (
                            <div
                                key={button.id}
                                className={styles.button_form_creator}
                                onClick={() => handleSelection(button.id)}
                            >
                                <div className={styles.button_form_creator_header}>
                                    <img
                                        src={button.icon}
                                        alt={`Иконка ${button.label}`}
                                        className={styles.img}
                                    />
                                    <span>{button.label}</span>
                                </div>
                                <img
                                    src={add_icon}
                                    alt={t('surveyForm.add_icon_alt')}
                                    className={styles.img}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                <Notification notify={notify} setNotify={setNotify} />
            </div>
        </div>
    );
};

export default TestForm;
